import { render, staticRenderFns } from "./ProjectArchiveListPage.vue?vue&type=template&id=cc57e3f8"
import script from "./ProjectArchiveListPage.vue?vue&type=script&lang=ts"
export * from "./ProjectArchiveListPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectArchiveListPage.vue?vue&type=style&index=0&id=cc57e3f8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports